/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateRewardDto } from '../../models/create-reward-dto';
import { Reward } from '../../models/reward';

export interface RewardsControllerCreate$Params {
      body: CreateRewardDto
}

export function rewardsControllerCreate(http: HttpClient, rootUrl: string, params: RewardsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<Reward>> {
  const rb = new RequestBuilder(rootUrl, rewardsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Reward>;
    })
  );
}

rewardsControllerCreate.PATH = '/rewards';
